import { ActivityTab } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/ActivityTab/ActivityTab';
import { GeneralTab } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/GeneralTab/GeneralTab';
export const JaneDetailViewComponentMap = {
  GeneralTab,
  ActivityTab,
};

export type JaneDetailsViewActiveTabType = keyof typeof JaneDetailViewComponentMap;
